import React from "react";

const AWM = () => {
  const image1Url = process.env.PUBLIC_URL + "/awm-1.png";
  const image2Url = process.env.PUBLIC_URL + "/awm-2.png";

  return (
    <>
      <div className="bg-black text-white min-h-screen py-8 font-secondary">
        <div className="max-w-[1200px] mx-auto px-10 md:px-6">
          <h1 className="font-primary text-[2.7rem] text-white mb-2 text-left md:text-[2.2rem]">
            AWM (ATMOSPHERIC WIND MOMENTS)
          </h1>
          <div className="border-t border-gray-400 mb-10 w-full" />
          <img
            src={image1Url}
            alt="Server Room"
            className="block max-w-full h-auto my-10 mx-auto rounded-lg md:my-6"
          />
          <img
            src={image2Url}
            alt="Plant on Desk"
            className="block max-w-full h-auto my-10 mx-auto rounded-lg md:my-6"
          />
          <p className="text-[1.1rem] text-[#bfc5c5] leading-relaxed mb-6 text-left md:text-base">
            To ensure the system's effectiveness, we implement ongoing
            monitoring and maintenance protocols, while adhering to data privacy
            and ethical considerations. This project aims to enhance our
            understanding of atmospheric dynamics, ultimately contributing to
            better predictive capabilities and climate resilience strategies.
            Continuous research and collaboration with academic institutions
            will drive the evolution of this work, keeping pace with
            advancements in AI and atmospheric sciences.
          </p>
        </div>
      </div>
    </>
  );
};

export default AWM;
